<div
  class="file-target-container"
  [class.file-target-container--error]="
    formControl.touched && formControl.invalid
  "
  [class.file-target-container--disabled]="props.disabled || false"
>
  <div class="hstack justify-content-between mb-1 pe-3">
    <mat-label class="file-target-label">
      <span>{{ props.label }}</span>
      <ng-container *ngIf="props.required"> *</ng-container>
    </mat-label>
  </div>
  <lui-file-drag-and-drop
    class="mb-2"
    [accept]="acceptedFormats"
    [button]="uploadButton"
    [multiple]="props.multiple"
    [required]="props.required"
    [disabled]="props.disabled || false"
    (filesAdded)="onFilesAdded($event)"
    (filesRejected)="onFilesRejected($event)"
    (filesRemoved)="onFilesRemoved($event)"
  >
    <div class="file-target-field p-3" #targetDrop>
      <div class="hstack flex-column flex-sm-row">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <div class="file-target-item file-target-icon">
            <lui-avatar color="grayMedium" [size]="64">
              <mat-icon svgIcon="doc_upload_thin"></mat-icon>
            </lui-avatar>
          </div>
          <div class="file-target-item file-text pe-sm-4 ps-1">
            <ng-container i18n>Drag and drop your files here</ng-container
            >&nbsp;<span class="mat-body-strong" i18n>or</span>
          </div>
        </div>
        <div class="file-target-item file-target-btn ms-auto" #uploadButton>
          <button
            luiButton
            type="button"
            class="w-100"
            [disabled]="props.disabled || false"
            i18n
            >Browse files</button
          >
        </div>
      </div>
    </div>

    <div class="mt-1 mat-small" *ngIf="props.hint">{{ props.hint }}</div>

    <mat-error
      *ngIf="formControl.touched || rejectedFileNames.length"
      class="file-target-error d-flex flex-wrap"
    >
      <p *ngIf="formControl.invalid && formControl.hasError('required')">
        * This field is required
      </p>
      <div *ngIf="rejectedFileNames.length">
        The following files failed to upload. Please upload an accepted format:
        {{ acceptedFormatNames }}
        <ul class="file-target-list">
          <li *ngFor="let fileName of rejectedFileNames">
            {{ fileName }}
          </li>
        </ul>
      </div>
    </mat-error>
  </lui-file-drag-and-drop>

  <div
    class="file-target-field p-1 mb-2"
    *ngFor="let file of formControl.value"
  >
    <div class="d-flex gap-1">
      <div class="flex-1">
        <div class="hstack gap-1">
          <div class="file-target-img-container">
            <lui-image
              *ngIf="file.isImage; else documentTemplate"
              [src]="file.src"
              [ratio]="'1x1'"
            ></lui-image>
            <ng-template #documentTemplate>
              <lui-avatar color="grayMedium" [size]="56">
                <mat-icon svgIcon="document_thin"></mat-icon>
              </lui-avatar>
            </ng-template>
          </div>
          <a
            luiLink
            style="pointer-events: all"
            class="mat-xs text-break"
            [href]="file.src"
            [download]="file.name"
            >{{ file.name }}</a
          >
        </div>
      </div>

      <div class="flex-none">
        <button
          luiIconButton
          size="sm"
          type="button"
          (click)="removeFile(file)"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
